require('./style.less');

var Marionette = require('marionette'),
    HitCountView = require('../hitSelectedCount/view'); // this may be variable -- not on hit count view


module.exports = Marionette.LayoutView.extend({

    tagName: 'tr',

    ROW_TYPE_CLASS_NAME: '',

    template: require('./template.hbs'),

    className: function() {

        return 'fr-hit-row-view fr-hit-row-parent ' + this.ROW_TYPE_CLASS_NAME + ' fr-row-' + this.model.get('rowLevel');
    },

    initialize: function (options) {

        this.channel = options.channel;

        this.listenTo( this.model, 'updateIsApplied', this.updateIsApplied );
        this.listenTo( this.model, 'updateIsCollapsed', this.updateIsCollapsed );

    },

    serializeData: function() {

        var m = this.model;

        return {
            isApplied: m.get('isApplied')
        };

    },

    onRender: function() {

        this.updateIsCollapsed(); // Not in template now, more logic involved
        this.showHitCountView();

    },

    regions: {
        hitCountRegion: '.fr-page-hit-count-region'
    },

    ui: {
        collapsibleBtn: '.collapsible-btn',
        selectHitCb:    '.fr-select-hit-cb'
    },

    events: {
        'click @ui.collapsibleBtn': 'collapseBtnClick',
        'click @ui.selectHitCb':    'appliedInputBoxClicked',
        'mouseenter': 'mouseEnter',
        'mouseleave': 'mouseLeave'
    },

    showHitCountView: function() {

        var hits = this.model.getLowestLevelChildren();

        var nAppliedHits = 0;

        if ( hits.length > 0 ) {

            nAppliedHits = hits.filter( function(hit) {
                return hit.get('isApplied');
            }).length;
        }

        this.hitCountRegion.show( new HitCountView({
            numberHits: hits.length,
            numberAppliedHits: nAppliedHits
        }));

    },

    // will toggle the model but also needs to take the header into account
    collapseBtnClick: function() {
        this.channel.trigger('findAndRedact:updatePostCollapseRowClick', this.model );
    },


    appliedInputBoxClicked: function( ) {
        this.channel.trigger('findAndRedact:updatePostResultRowIncludeClick', this.model );
    },


    updateIsApplied: function() {

        this.ui.selectHitCb[0].checked = this.model.get('isApplied');
        this.showHitCountView();

    },
    updateIsCollapsed: function() {

        var m = this.model,
            collapse = m.get('isCollapsed');

        /* Collapse Button */
        this.ui.collapsibleBtn.removeClass('icon-right-dir-1 icon-down-dir-1');

        // TODO: plugin
        if ( collapse ) {
            this.ui.collapsibleBtn.addClass('icon-right-dir-1');
        }
        else {
            this.ui.collapsibleBtn.addClass('icon-down-dir-1');
        }

        /* Toggle row visibility */

        // overlap with hit row ...
        var parent = m.getParent();

        if ( !m.get('isRoot') && parent && !parent.get('isRoot')  ) {
            this.$el.toggleClass( 'hide', parent.get('isCollapsed') );
        }

    },

    mouseEnter: function() {

        this.model.getLowestLevelChildren().forEach( function( hit ) {
            hit.setIsMouseOverRowView( true );
        });

    },

    mouseLeave: function() {

        this.model.getLowestLevelChildren().forEach( function( hit ) {
            hit.setIsMouseOverRowView( false );
        });

    }


});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/baseRowView/view.js
 ** module id = 619
 ** module chunks = 0
 **/